import React from 'react';
import { BrowserRouter , Routes , Route } from "react-router";
import Login from './Pages/Login';
import Home from './Pages/Home';
import Booking from './Pages/Booking';
import Attendees from './Pages/Attendees';
import SiteContent from './Pages/SiteContent';
import Vehicles from './Pages/Vehicles';
import Gallery from './Pages/Gallery';

const RouteUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Login />}/>
                <Route path='/home' element={<Home />}/>
                <Route path='/booking' element={<Booking />}/>
                <Route path='/users' element={<Attendees />}/>
                <Route path='/content' element={<SiteContent />}/>
                <Route path='/vehicles' element={<Vehicles />}/>
                <Route path='/gallery' element={<Gallery />}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RouteUrls;